import React from 'react';
import { useNavigate } from 'react-router-dom';

const PublicCTA = ({ showDivider = true }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundColor: '#EEE7D8',
        padding: '40px 20px',
        marginTop: '80px',
        borderTop: showDivider ? '1px solid #D6D0C2' : 'none'
      }}
    >
      <div
        className="flex flex-col items-center justify-center gap-1 md:flex-row md:gap-6"
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <div className="flex items-center justify-center gap-2">
          <span
            style={{
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontSize: '16px',
              color: '#51120A'
            }}
          >
            Made with
          </span>
          <img
            src="https://customer-assets.emergentagent.com/job_cookbookai/artifacts/2wfbb2cf_wellby-logo.svg"
            alt="Wellby"
            style={{
              height: '48px',
              width: 'auto',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          />
        </div>
        <button
          onClick={() => navigate('/')}
          className="text-link whitespace-nowrap"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontSize: '16px',
            padding: 0
          }}
        >
          Create your own
        </button>
      </div>
    </div>
  );
};

export default PublicCTA;
